import React, { useState, useEffect } from "react";

import PieChart from "./Chart/PieChart";
import BiaxialLineChart from "./Chart/BiaxialLineChart";

const ContractClassifyCommon = ({ title, data, year, titleYAxis, height = 100 }) => {
  const [pieData, setPieData] = useState(false);
  useEffect(() => {
    if (data) {
      var dataYear = data.find((l) => l.year == year);
      setPieData(dataYear ? dataYear.stat : false);
    } else {
      setPieData(false);
    }
    return () => {};
  }, [title, data, year, pieData]);

  return pieData ? (
    <div className="card">
      <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
        <h4 className="card-header-title">{title}</h4>
      </div>
      <div className="card-body pb-0" style={{ height: "auto" }}>
        <div>
          <PieChart data={pieData} height={150} />
        </div>
        <div style={{height: "300px"}}>
          <BiaxialLineChart data={data} bizYear={year} titleYAxis={titleYAxis} />
        </div>
      </div>
    </div>
  ) : (
    <div className="card">
      <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
        <h4 className="card-header-title">{title}</h4>
      </div>
      <div className="card-body" style={{ height: "auto" }}>
        {`해당 년도의 통계 자료가 없습니다.`}
      </div>
    </div>
  );
};
export default ContractClassifyCommon;
